/* 库存录入 */
<template>
  <div id="orderInsert" class="q-pa-md">
    <PageHeader content="库存录入" />
    <el-form ref="form" :model="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <CustSelector ref="custSelector" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="库存名称">
            <el-input v-model="form.stockName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <YarnSelector ref="yarnSelector" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="库存类型">
            <el-select v-model="form.stockType" placeholder="请选择类型" style="width: 100%;">
              <el-option label="胚纱" value="0"></el-option>
              <el-option label="色纱" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" v-if="form.stockType == 0">
          <el-form-item label="缠绕类型">
            <el-select v-model="form.windType" placeholder="请选择类型" style="width: 100%;">
              <el-option label="筒纱" value="0"></el-option>
              <el-option label="绞纱" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="位置">
            <el-input v-model="form.location"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input type="textarea" v-model="form.remark" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="库存">
            <el-checkbox v-model="checked">初始化库存</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

      <div v-if="checked">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="进出方向">
              <el-select
                v-model="form.stockDetails.direction"
                placeholder="请选择方向"
                style="width: 100%;"
              >
                <el-option label="进" value="0"></el-option>
                <el-option label="出" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发生日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="form.stockDetails.happenDate"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="数量(KG)">
              <el-input type="number" v-model="form.stockDetails.quantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单价(元)">
              <el-input type="number" v-model="form.stockDetails.unitPrice"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="批号">
              <el-input v-model="form.stockDetails.batchNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来源批号">
              <el-input v-model="form.stockDetails.sourceNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="form.stockDetails.remark"
            :autosize="{ minRows: 4, maxRows: 10}"
          ></el-input>
        </el-form-item>
      </div>

      <el-form-item>
        <el-button type="primary" @click="saveStock">立即创建</el-button>
        <el-button @click="cancel">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>


<script>
import PageHeader from "../components/PageHeader.vue";
import CustSelector from "../components/CustSelector.vue";
import YarnSelector from "@/components/YarnSelector.vue";
export default {
  components: {
    PageHeader,
    CustSelector,
    YarnSelector,
  },
  data() {
    return {
      form: { stockDetails: {} },
      checked: false,
    };
  },
  methods: {
    cancel() {
      this.$router.back(-1);
    },
    saveStock() {
      this.form.customerNo = this.$refs.custSelector.customerNo;
      this.form.yarnType = this.$refs.yarnSelector.selectYarnId;
      console.log(JSON.stringify(this.form));
      var self = this;
      this.$axios.post("/erp/stock", self.form).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.$message({
            message: "保存成功",
            type: "success",
          });
          //保存成功返回ID
          self.$router.push("/stock/details/" + response.data.data);
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
  },
  created: function () {
    console.log("OrderInsert created");
    this.getOrderNo();
  },
};
</script>

<style scoped>
.el-form {
  --width: 600px;
  margin-top: 50px;
}
</style>